import React from "react"

export const HtmlString: React.FC<{
    str: string,
}> = ({str}) => {
    return <span dangerouslySetInnerHTML={{__html: str}} />
}